const PREF_KEY = "ph_intro_sound";
let ctx = null;

export const soundPref = () => {
  try { return localStorage.getItem(PREF_KEY) === "1"; } catch { return false; }
};
export const setSoundPref = (on) => {
  try { localStorage.setItem(PREF_KEY, on ? "1" : "0"); } catch { /* storage blocked */ }
};

/** Prepares audio; call from a click so browsers allow playback. */
export function unlockSound() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

/** Soft synthesized energy pulse: a low swell with a gentle airy shimmer (~1s). */
export function playPulse() {
  const ac = unlockSound();
  if (!ac || ac.state !== "running") return;
  const t = ac.currentTime;
  const master = ac.createGain();
  master.gain.setValueAtTime(0.0001, t);
  master.gain.exponentialRampToValueAtTime(0.16, t + 0.06);
  master.gain.exponentialRampToValueAtTime(0.0001, t + 1.1);
  master.connect(ac.destination);

  const osc = ac.createOscillator();
  osc.type = "sine";
  osc.frequency.setValueAtTime(70, t);
  osc.frequency.exponentialRampToValueAtTime(240, t + 0.35);
  osc.frequency.exponentialRampToValueAtTime(160, t + 1);
  osc.connect(master);

  const shimmer = ac.createOscillator();
  const sg = ac.createGain();
  shimmer.type = "triangle";
  shimmer.frequency.setValueAtTime(880, t);
  shimmer.frequency.exponentialRampToValueAtTime(1320, t + 0.5);
  sg.gain.setValueAtTime(0.0001, t);
  sg.gain.exponentialRampToValueAtTime(0.05, t + 0.12);
  sg.gain.exponentialRampToValueAtTime(0.0001, t + 0.8);
  shimmer.connect(sg).connect(master);

  osc.start(t); shimmer.start(t);
  osc.stop(t + 1.15); shimmer.stop(t + 1.15);
}
